export const MAX_SEO_DESCRIPTION_LENGTH = 200
export const MAX_SEO_TITLE_LENGTH = 60
export const MIN_SEO_DESCRIPTION_LENGTH_SUGGESTION = 155
export const MAX_SEO_DESCRIPTION_LENGTH_SUGGESTION = 160
